/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRuler2Off = createReactComponent("outline", "ruler-2-off", "IconRuler2Off", [["path", { "d": "M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7", "key": "svg-0" }], ["path", { "d": "M16 7l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M10 13l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M7 16l-1.5 -1.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

export { IconRuler2Off as default };
//# sourceMappingURL=IconRuler2Off.mjs.map
